'use client'

import React from 'react'

import { useExtractSpaceProps } from '../../hooks'
import { SpaceProps } from '../../themes'
import { Checkbox, CheckboxProps } from '../Checkbox'
import { Field } from '../Field'

export interface CheckboxFieldProps extends CheckboxProps, SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Icon to display before the error message
   */
  errorIcon?: React.ReactNode

  /**
   * Error messages
   */
  errorMessages?: string | string[]

  /**
   * Icon to display before the caption message
   */
  captionIcon?: React.ReactNode

  /**
   * Caption
   */
  captionMessages?: string | string[]
}

export const CheckboxField = React.forwardRef(
  (
    {
      className,
      errorIcon,
      errorMessages,
      captionIcon,
      captionMessages,
      ...props
    }: CheckboxFieldProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    const [spaceProps, checkboxProps] = useExtractSpaceProps(props)

    return (
      <Field className={className} {...spaceProps}>
        <Field.Content>
          <Checkbox ref={ref} {...checkboxProps} />
        </Field.Content>

        <Field.Messages
          mt={2}
          type="error"
          messages={errorMessages}
          icon={errorIcon}
        />

        <Field.Messages
          mt={errorMessages || (errorMessages && errorMessages.length) ? 1 : 2}
          type="caption"
          messages={captionMessages}
          icon={captionIcon}
        />
      </Field>
    )
  },
)

CheckboxField.displayName = 'CheckboxField'
